<template>
  <div class="magicstone-scan-page">
    <img class="logo" src="/static/images/magicstone/ms-logo.png" />
    <img class="system" src="/static/images/magicstone/ms-system.png" />
    <div class="white-box">
      <div class="left-box">
        <div class="info-line">
          <span class="info-label">企业信息：</span>
        </div>
        <div class="info-line">
          <span class="info-label">经销商：</span>
        </div>
        <div class="info-line">
          <span class="info-label">经销省份：</span>
        </div>
        <div class="info-line">
          <span class="info-label">批次信息：</span>
        </div>
      </div>
      <div class="right-box">
        <div class="info-line">
          <span class="info-value">{{ companyInfo }}</span>
        </div>
        <div class="info-line">
          <span class="info-value">{{ dealer }}</span>
        </div>
        <div class="info-line">
          <span class="info-value">{{ province }}</span>
        </div>
        <div class="info-line">
          <span class="info-value">{{ batchInfo }}</span>
        </div>
      </div>
    </div>
    <button  @click="toScanPage" class="action-button">点击按钮扫码查询</button>
    <div class="bottom-container">
      <img class="bottom" src="/static/images/magicstone/ms-bottom.png" />
    </div>
    <div class="bottom-overlay"></div>
  </div>
</template>

<style scoped>
.magicstone-scan-page {
  width: 100vw;
  height: 100vh;
  background-color: rgb(175, 244, 39);
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow-y: auto;
  position: relative;
}

.logo {
  margin-top: 7vh;
  width: 30vw;
  height: auto;
}

.system {
  margin-top: 4vh;
  width: 75vw;
  height: auto;
}

.white-box {
  margin-top: auto;
  width: 85vw;
  height: 40vh;
  background-color: white;
  border-radius: 8px;
  display: flex;
  padding: 3vh 4vw 3vh 4vw;
}

.left-box {
  width: 30vw;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.right-box {
  width: 55vw;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.info-line {
  display: flex;
  align-items: center;
  margin-bottom: 2vh;
  min-height: 6vh;
}

.info-line:last-child {
  margin-bottom: 0;
}

.info-label {
  font-size: 3.8vw;
  color: black;
  text-align: justify;
  text-align-last: justify;
  width: 100%;
}

.info-value {
  font-size: 3.8vw;
  color: black;
  text-align: left;
  width: 100%;
}

.action-button {
  margin-top: 5vh;
  width: 85vw;
  height: 6vh;
  background: linear-gradient(to bottom, rgb(242, 240, 73), rgb(146, 212, 13));
  border: none;
  border-radius: 14px;
  color: black;
  font-size: 4.5vw;
  font-weight: bold;
  cursor: pointer;
  outline: none;
  letter-spacing: 0.5vw;
}

.bottom-container {
  margin-top: auto;
  margin-bottom: 1vh;
  position: relative;
  width: 60vw;
}

.bottom {
  width: 60vw;
  height: auto;
  position: relative;
  z-index: 2;
}

.bottom-overlay {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100vw;
  height: 7vh;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 1;
}

.scan-text {
  margin-top: 5vh;
  font-size: 6.2vw;
  letter-spacing: 2vw;
}

.scan-img {
  margin-top: 8vh;
  width: 40vw;
  height: auto;
}

.tip-text {
  margin-top: 4vh;
  color: black;
  font-size: 4.2vw;
}

.query-container {
  margin-top: 2.5vh;
  width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}

.query-box {
  display: flex;
  width: 76vw;
  overflow: hidden;
}

.query-input {
  flex: 1;
  height: 6vh;
  border: 1.5px solid black;
  border-right: none;
  padding: 0 3vw;
  font-size: 4vw;
  background: white;
  color: #333;
  outline: none;
}

.query-button {
  width: 20vw;
  height: 6vh;
  background: black;
  color: white;
  border: none;
  font-size: 4.5vw;
  font-weight: bold;
  cursor: pointer;
  outline: none;
}
</style>
<script>
import { getTrace } from '../../api/api'
export default {
  name: 'MagicStoneTrace',
  data() {
    return {
      eno: '',
      code: '',
      traceResult: {},
      companyInfo: '秦皇岛魔石科技有限责任公司',
      dealer: '',
      province: '',
      batchInfo: ''
    }
  },
  methods: {
    toScanPage() {
      window.location.replace('/magicstone/scan');
    },
    queryTrace(code, eno) {
      getTrace(code, eno).then(res => {
        if (res.data.code != 200) {
          alert('查询失败');
        } else if (res.data.data) {
          this.traceResult = res.data.data;
          this.companyInfo = this.traceResult.customizeTradeColumn2 || '';
          this.dealer = this.traceResult.customizeTradeColumn3 || '';
          this.province = this.traceResult.customizeTradeColumn4 || '';
          this.batchInfo = this.traceResult.customizeTradeColumn1 || '';
        } 
      }).catch(err => {
        console.error('查询失败:', err);
        alert('查询失败，请稍后重试');
      });
    }
  },
  mounted() {
    const params = this.$route.query;
    const code = params.c;
    const eno = params.eno;
    if (eno) {
      this.eno = eno;
    }
    if (code) {
      this.code = code;
    }
    this.queryTrace(this.code, this.eno);
  }
}
</script>



// WEBPACK FOOTER //
// src/components/MagicStone/Trace.vue